import * as React from 'react';
import { createRoot } from 'react-dom/client';

import { App as Header } from './component/AppHeader';
import { App as Footer } from './component/AppFooter';
import { TApiResponse, TConfEnteDati } from 'Portal/mixin/types';
import { apiConfigurationDefault } from './component/http_client/api_configuration';
import { ApiClient } from "Portal/http_client/api_client";
import { getConfEnteHippo } from 'Portal/mixin/functions';
import AppProvider from './component/mixin/app_provider';

const apiConfiguration = apiConfigurationDefault;
const apiClient = new ApiClient(apiConfiguration);

const configEnte: TApiResponse = await getConfEnteHippo(apiClient);
const datiConf: TConfEnteDati = configEnte.dati;

/* carico i dati dell'ente nel context nello state */
const context = {
 confEnte: datiConf, 
 userLogged: datiConf.utente_loggato,
 tabMenuAutenticatoVisibile : false
};

const headerDiv = document.getElementById('reactHeader') as HTMLElement;
const footerDiv = document.getElementById('reactFooter') as HTMLElement;

//const appNome = (document.querySelector('#appNome') as HTMLElement)?.dataset.appNome;

const infoUtente = (document.querySelector('#infoUtente') as HTMLElement)?.dataset;

if (infoUtente != null) {
  context.confEnte.utente_loggato = (infoUtente.cognome != null || infoUtente.nome != null),
  context.userLogged = context.confEnte.utente_loggato;
  context.confEnte.utente_cognome = infoUtente.cognome;
  context.confEnte.utente_nome = infoUtente.nome;
}

if (headerDiv && footerDiv) {
  
  // const reactHeader = ReactDOM.createRoot(
  //   headerDiv
  // )
  // const reactFooter = ReactDOM.createRoot(
  //   footerDiv
  // )
    
  const reactHeader = createRoot(headerDiv!);

  const reactFooter = createRoot(footerDiv!);

  reactHeader.render(
    <React.StrictMode>
      <AppProvider context={context}>
        <Header />
      </AppProvider>
    </React.StrictMode>
  );

  reactFooter.render(
    <React.StrictMode>
      <AppProvider context={context}>
        <Footer></Footer>
      </AppProvider>
    </React.StrictMode>
  );
}
